module.exports = __webpack_public_path__ + "static/EnChartDesktop-1497a34b8d402156ef5b3e94a86bdca8.svg";